import { render, staticRenderFns } from "./ClientMandates.vue?vue&type=template&id=2ac68192&scoped=true&"
import script from "./ClientMandates.vue?vue&type=script&lang=js&"
export * from "./ClientMandates.vue?vue&type=script&lang=js&"
import style0 from "./ClientMandates.vue?vue&type=style&index=0&id=2ac68192&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac68192",
  null
  
)

export default component.exports